import styled from '@emotion/styled'
import * as React from 'react'

import { ButtonIcon } from '~ui/components/buttons/ButtonIcon/ButtonIcon'
import { IconChevronLeft, IconChevronRight } from '~ui/components/icons/specific/IconChevrons'
import { getSpacingValue, TSingleSpace } from '~ui/styleGuide/spaces'

type TPositionProps = {
  buttonPosition?: {
    /**
     * The start vertical position of the button.
     */
    position?: `top` | `center`
    /**
     * css length value. If there is a need to align scroll buttons on the y-axis.
     */
    verticalOffset?: string
    /**
     * css length value. If there is a need to align scroll buttons on the x-axis.
     */
    horizontalOffset?: TSingleSpace
  }
}

type TProps = NoChildren &
  TPositionProps & {
    buttonType: 'right' | 'left'
    onClick?: PropsOf<typeof ButtonIcon>['onClick']
  }

type TStyledProps = Pick<Defined<TProps['buttonPosition']>, 'verticalOffset'>

const propForwardOptions = {
  shouldForwardProp: (propName: string) => propName !== `verticalOffset`,
}

const StyledScrollButton = styled(ButtonIcon, propForwardOptions)<TStyledProps>`
  transform: translateY(${({ verticalOffset }) => verticalOffset});
  opacity: 0.7;
  transition: opacity 0.4s;

  &:hover {
    opacity: 1;
  }
`

// size of the icon inside of the ButtonIcon (scroll button)
const ICON_SIZE = `1.5rem`

export const ScrollOverflowButton: React.FC<TProps> = ({ buttonType, onClick, buttonPosition }) => {
  const isLeftButton = buttonType === 'left'
  const horizontalOffset = buttonPosition?.horizontalOffset
    ? getSpacingValue(buttonPosition.horizontalOffset)
    : 0

  return (
    <StyledScrollButton
      position={`absolute`}
      left={isLeftButton ? horizontalOffset : undefined}
      right={isLeftButton ? undefined : horizontalOffset}
      icon={isLeftButton ? IconChevronLeft : IconChevronRight}
      iconSize={ICON_SIZE}
      bgColor={`tertiary`}
      padding={`small`}
      onClick={onClick}
      marginRight={`auto`}
      shadow={`light`}
      verticalOffset={buttonPosition?.verticalOffset ?? `0px`}
      top={buttonPosition?.position === `top` ? 0 : undefined}
    />
  )
}
